export default "__VITE_ASSET__CpW$exwb__"